/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Boris Kudlač (kudlac@cadwork.cz)
 *
 */

import ViewMode from "App/view/modes/view_mode";
import {vec2, vec3} from "gl-matrix";
import {logInfo} from "App/debug";
import Messenger from "App/messenger";
import ViewWebVR from "App/view/view_web_vr";
import RenderDocument from "App/render_document";

export default
class ViewModeWebVR extends ViewMode {

    protected _pgc: any = {};

    private _frameData: VRFrameData = new VRFrameData;
    private _vrDisplay: VRDisplay = null;
    private _cameraLookingDownActor: any = {};
    private _displayPresentChangeCallback: () => void;
    private _displayActivateCallback: (Event) => void;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        let view = new ViewWebVR(this, this.rdocument, vec2.fromValues(0, 0), vec2.fromValues(100, 100));

        this.addView(view);

        this.activeView = view;

        this.createLights();

        // force light settings for the view
        // this.sunlight.setPosition(vec4.fromValues(0.6, 0.6, 1.0, 0.0));
        // this.sceneAPI.lightingModule.enableVR(true);

        this._initPresentChangeListener();

        this._frameData = new VRFrameData;
        this._vrDisplay = null;

        this._cameraLookingDownActor = {
            lastTickTime: null,
            accumulatedTime: 0.0,
            exitPresentDispatched: false
        };

        this._pgc = {
            downVector: vec3.fromValues(0, -1, 0)
        };
    }

    public requestPresent() {
        window.addEventListener('vrdisplaypresentchange', this._displayPresentChangeCallback, false);
        // this is actually for samsung internet webvr
        window.addEventListener('vrdisplayactivate', this._displayActivateCallback, false);

        return this._setFullscreen(true);
    }

    public exitPresent() {
        window.removeEventListener('vrdisplaypresentchange', this._displayPresentChangeCallback);
        window.removeEventListener('vrdisplayactivate', this._displayActivateCallback);

        return this._setFullscreen(false);
    }

    public getFrameData(): VRFrameData {
        return this._frameData;
    }

    public getVRDisplay(): VRDisplay {
        return this._vrDisplay;
    }

    public tick() {
        /*if (!this.activeView) {
            return;
        }

        if (!this._cameraLookingDownActor.lastTickTime) {
            this._cameraLookingDownActor.lastTickTime = performance.now();
        }

        // check when camera is looking down more than one second and in this case just dispatch webvr model to end
        let camera = this.activeView.getCamera();

        if (Math.abs(vec3.dot(camera.getCameraDirection(), this._pgc.downVector)) > 0.999) {
            this._cameraLookingDownActor.accumulatedTime += (performance.now() - this._cameraLookingDownActor.lastTickTime) / 1000.0;
        }
        else {
            this._cameraLookingDownActor.accumulatedTime = 0.0;
            this._cameraLookingDownActor.lastTickTime = null;
        }

        // this is a temporary solution for exiting the webvr presenting mode as there is no gui which allow us to exit the presentation mode of the webvr
        // we wll replace this in future by impementing a 3d actor (button) which ll be rendered just bellow the camera
        if (this._cameraLookingDownActor.accumulatedTime > 2.0) {
            if (!this._cameraLookingDownActor.exitPresentDispatched) {

                this._cameraLookingDownActor.exitPresentDispatched = true;

                Messenger.fireCDWKEvent(
                    this.sceneAPI._glCanvasParentTag,
                    "cwx3d_webVRExitPresentRequested", null
                );
            }
        }*/

        super.tick();
    }

    public render() {
        let vrDevice = this.canvas.getVRDevice();

        if (!this.canvas.isWebVRRequestAnimationFrameScheduled()) {
            return;
        }

        // grab data from position sensor
        if (!vrDevice.isReady()) {
            return;
        }

        if (!vrDevice.presenting) {
            return;
        }

        vrDevice.display.getFrameData(this._frameData);
        this._vrDisplay = vrDevice.display;

        super.render();

        vrDevice.display.submitFrame();

        this.scheduleRedraw();
    }

    private _initPresentChangeListener() {

        this._displayPresentChangeCallback = () => {
            let vrDevice = this.canvas.getVRDevice();
            vrDevice.presenting = vrDevice.display && vrDevice.display.isPresenting;
            logInfo("_initPresentChangeListener: " + vrDevice.presenting);

            // here we change the rendering parameters as we enter the vr mode (this is done differently in our engine) so
            // we will do in here in viewmodewebvr class - probably :)
            if (vrDevice.presenting) {
                this.canvas.setWebVRRequestAnimationFrameEnabled(true);
            } else {
                this.canvas.setWebVRRequestAnimationFrameEnabled(false);
                Messenger.fireCDWKEvent(this.sceneAPI.getCanvasParentTag(), "cwx3d_webVRExitPresenting", {});
            }
        };

        this._displayActivateCallback = (event) => {
            event.display.requestPresent([{source: this.canvas.getHTMLCanvas()}]);
        };

        // window.addEventListener('vrdisplaypresentchange', this._displayPresentChangeCallback, false);

        // // this is actually for samsung internet webvr
        // window.addEventListener('vrdisplayactivate', this._displayActivateCallback, false);
    }

    private _setFullscreen(aEnable: boolean) {
        let vrDevice = this.canvas.getVRDevice();

        if (vrDevice.display === null) {
            logInfo("Entering fullscreen failed: reason is that no VR hardware found.");
            return null;
        }

        logInfo("set fullscreen: " + aEnable);
        if (aEnable && !vrDevice.display.isPresenting) {
            vrDevice.display.requestPresent([{source: this.canvas.getHTMLCanvas()}]);
            logInfo("requestPresent on " + this.canvas.getHTMLCanvas());
        }
        else if (!aEnable && vrDevice.display.isPresenting) {
            vrDevice.display.exitPresent();
        }
    }
}
